import React from 'react';

import { OilSettings } from 'screens/shared';

const GearboxOil = (props) => {
  const engineValues = {
    reset: '400.0'
  };

  return <OilSettings engineValues={engineValues} {...props} />;
};

export default GearboxOil;



// WEBPACK FOOTER //
// ./src/screens/Diesel/DieselSettings/GearboxOil/GearboxOil.js